export default __webpack_public_path__ + "static/media/professional.2f7ee69d.svg";